import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { IModel } from '../../core/IModel';
import { IArticle } from '../../core/IArticle';
import { LangDataService } from '../../core/lang-data.service';
import { IDataSource } from '../../core/IDataSource';
import { DataProviderService } from '../../core/data-provider.service';
import { IMetalColor } from '../../core/IMetalColor';
import { SpecialColorSelection } from '../SpecialColorSelection';
import { FormatterService } from 'app/core/formatter.service';
import { ArticleDataService } from 'app/core/article-data.service';

@Component({
    selector: 'product-description-text',
    templateUrl: './product-description-text.component.html',
    styleUrls: ['./product-description-text.component.scss']
})
export class ProductDescriptionTextComponent implements OnInit, OnChanges {
    private metalColorsMap: { [id: number]: IMetalColor };

    @Input()
    public model: IModel;

    @Input()
    public article: IArticle;

    @Input()
    public displayArticleDetails: boolean;

    @Input()
    public displayPrewallDetails: boolean;

    @Input()
    public specialColor: SpecialColorSelection;

    /** Remains empty, if specialColor is set. */
    public specialColorArticles: IArticle[] = [];

    public get displayAllSpecialColorArticles(): boolean {
        return this.specialColorArticles.length > 0;
    }

    public get productText(): string {
        if (this.article) {
            return this.article['catalog-text'].replace(/&nbsp;/g, ' ');
        }
        else {
            // use catalog text in case there is no article context available
            return this.model['catalog-text'].replace(/&nbsp;/g, ' '); 
        }
    }

    public representativeColorStringHeading: string;
    public representativeColorStringValue: string;

    constructor(
        private lang: LangDataService,
        private dataProvider: DataProviderService,
        private articleService: ArticleDataService,
        private formatter: FormatterService,
    ) {}

    public ngOnChanges(changes: SimpleChanges) {
        this.reset();
    }

    public ngOnInit(): void {
        this.dataProvider.getData(true).subscribe(
            (data: IDataSource) => {
                this.metalColorsMap = data["metal-colors"];
                this.reset();
            }, console.error);
    }

    private reset() {
        if (this.metalColorsMap === undefined)
            return;

        if (this.specialColor === undefined) {
            delete this.representativeColorStringHeading;
            delete this.representativeColorStringValue;
        } else {
            if (this.specialColor.isRalColor) {
                this.representativeColorStringHeading = this.lang.getString('special-color-plate');

                const ralColorId = this.specialColor.colorId;
                if (this.specialColor.isRalMatt)
                    this.representativeColorStringValue = `${this.lang.getString('special-color-ral-matt')} ${ralColorId}`;
                else
                    this.representativeColorStringValue = `${this.lang.getString('special-color-ral-glossy')} ${ralColorId}`;
            } else {
                const metalColorId = this.specialColor.colorId;
                this.representativeColorStringHeading = this.lang.getString('special-color-metal');
                this.representativeColorStringValue = this.lang.getString(this.metalColorsMap[metalColorId]["label-ref"]);
            }
        }

        if (this.article && this.articleService.isSpecialColorArticle(this.article) && !this.specialColor)
            this.articleService.getSpecialArticlesOfModel(this.model.key).toArray().toPromise()
                .then(articles => this.specialColorArticles = articles);
        else
            this.specialColorArticles = [];
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/product-description-text/product-description-text.component.ts